import { render, staticRenderFns } from "./MultiPointPacketBuilder.vue?vue&type=template&id=0c28a105&"
import script from "./MultiPointPacketBuilder.vue?vue&type=script&lang=ts&"
export * from "./MultiPointPacketBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports